import { render, staticRenderFns } from "./edit-store-menu-item.vue?vue&type=template&id=e1e2f690&scoped=true&"
import script from "./edit-store-menu-item.vue?vue&type=script&lang=js&"
export * from "./edit-store-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e2f690",
  null
  
)

export default component.exports